import apiClient from "./apiClient";

const getTicketsForEvent = async (slug, token) => {
    try {
        const params = new URLSearchParams();
        if (token) params.append("privateToken", token);
        const response = await apiClient.get(
            `/entradas/${slug}?${params.toString()}`
        );
        return response.data;
    } catch (error) {
        console.error("Error al obtener los tickets:", error);
        throw error;
    }
};

const getTicketsForUser = async (id) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await apiClient.get(`qr_for_user/${id}`, {
            headers: { Authorization: token },
        });
        return response.data;
    } catch (error) {
        console.error("Error al obtener los tickets:", error);
        return error;
    }
};

export default {
    getTicketsForEvent,
    getTicketsForUser,
};
